import { useAPIGetKinerjaHarianActive } from 'api/kinerja/kinerja-harian'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'

export function useKinerjaHarianActive() {
  const { periodYear, periodNo } = usePeriodContext()
  const { tipe } = useKinerjaTipe()

  const { data, isLoading, isSuccess } = useAPIGetKinerjaHarianActive({
    params: {
      skpYear: periodYear,
      skpPeriod: periodNo,
      tipe,
    },
    options: {
      enabled: Number.isInteger(periodYear) && Number.isInteger(periodNo),
      useErrorBoundary: false,
    },
  })

  const isActive = data?.data?.active === true
  const isPerencanaanReady = data?.data?.perencanaanState === 'READY'

  return { isActive, isPerencanaanReady, isLoading, isSuccess }
}
